import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {IddTraining} from "../../../shared/interface/idd-training";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {merge, ReplaySubject} from "rxjs";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";
import {Ofwca} from "../../../shared/interface/ofwca";
import {Router} from "@angular/router";
import {IddTrainingService} from "../../../shared/services/idd-training.service";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {filter, first, takeUntil} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {Dictionary} from "../../../shared/interface/dictionary";
import {MEETING_LEADER_INSURANCE_COMPANY} from "../../../shared/services/dict.service";
import {IddTrainingCertificate} from "../../../shared/interface/idd-training-certificate";
import {DenyIddCertificateDialogComponent} from "../deny-idd-certificate-dialog/deny-idd-certificate-dialog.component";
import {validate} from "codelyzer/walkerFactory/walkerFn";
import {UserService} from "../../../shared/services/user.service";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";

export interface CertificateOverviewDialogData {
  certificateId: string;
  certificateObject: IddTrainingCertificate;
  mode: string;
}

@Component({
  selector: 'app-idd-certificate-edit-dialog',
  templateUrl: './idd-certificate-edit-dialog.component.html',
  styleUrls: ['./idd-certificate-edit-dialog.component.scss']
})
export class IddCertificateEditDialogComponent implements OnInit, OnDestroy {
  @Input() iddTrainingObject?: IddTraining;

  certificateFormValid = false;
  certificateDenialForm: FormGroup;

  certificateForm: FormGroup;
  ofwcaControl: FormControl;
  iddTrainingControl: FormControl;
  meetingLeaderControl: FormControl;
  amlControl: FormControl;
  insuranceCompanyControl: FormControl;
  realisedAssetsMinutesControl: FormControl;
  realisedLifeMinutesControl: FormControl;
  realisedGeneralMinutesControl: FormControl;
  realisedAtControl: FormControl;
  realisedAssetsHoursPartControl: FormControl;
  realisedAssetsMinutesPartControl: FormControl;
  realisedLifeHoursPartControl: FormControl;
  realisedLifeMinutesPartControl: FormControl;
  realisedGeneralHoursPartControl: FormControl;
  realisedGeneralMinutesPartControl: FormControl;
  processingRequest = false;
  iddTrainingsSubject: ReplaySubject<ListResponse<IddTraining>> = new ReplaySubject<ListResponse<IddTraining>>(1);
  iddTrainings: IddTraining[] = [];
  selectedInsuranceCompany?: InsuranceCompany;
  selectedIddTraining?: IddTraining;
  selectedOfwca?: Ofwca;
  formErrors = {};
  currentYear = '';
  iddTrainingCertificateId: string;
  mode: string;
  certificate: IddTrainingCertificate;
  userPermissions: ReplaySubject<UserPermissions>;
  userPermissionss: UserPermissions;
  buttonOff = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<IddCertificateEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CertificateOverviewDialogData,
    private fb: FormBuilder,
    private router: Router,
    private iddTrainingService: IddTrainingService,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private userService: UserService,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.iddTrainingCertificateId = data.certificateId;
    this.certificate = data.certificateObject;
    this.mode = data.mode;

      this.certificateForm = fb.group({
        ofwca: this.ofwcaControl = fb.control(''),
        iddTraining: this.iddTrainingControl = fb.control('', [Validators.required]),
        meetingLeader: this.meetingLeaderControl = fb.control('', [Validators.required]),
        aml: this.amlControl = fb.control(''),
        insuranceCompany: this.insuranceCompanyControl = fb.control(''),
        realisedAssetsMinutes: this.realisedAssetsMinutesControl = fb.control(0),
        realisedLifeMinutes: this.realisedLifeMinutesControl = fb.control(0),
        realisedGeneralMinutes: this.realisedGeneralMinutesControl = fb.control(0),
        realisedAt: this.realisedAtControl = fb.control('', [Validators.required]),
      });

      this.insuranceCompanyControl.disable();
      this.realisedAssetsHoursPartControl = fb.control(0);
      this.realisedAssetsMinutesPartControl = fb.control(0);
      this.realisedLifeHoursPartControl = fb.control(0);
      this.realisedLifeMinutesPartControl = fb.control(0);
      this.realisedGeneralMinutesPartControl = fb.control(0);
      this.realisedGeneralHoursPartControl = fb.control(0);

      const currentDate = new Date();
      // if (currentDate.getMonth() < 2 ) {
      //   this.currentYear = (currentDate.getFullYear() - 1).toString();
      // }else {
        this.currentYear = (currentDate.getFullYear() ).toString();
      // }
  }

  ngOnInit(): void {
    this.userPermissions
      .pipe(takeUntil(this.destroyed$))
      .subscribe(value => {
        this.userPermissionss = value;
      });
    if (this.certificate.status.key !== 'declined'){
      this.buttonOff = false;
    } else {
      this.buttonOff = true;
    }
    if (this.certificate.iddTraining.ofwca){
      this.ofwcaControl.setValue(this.certificate.iddTraining.ofwca.uuid);
      this.ofwcaControl.disable();
    }
    this.ofwcaChanged(this.certificate.iddTraining.ofwca);
    this.certificateForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.certificateFormValid = this.certificateForm.valid;
      });

    this.iddTrainingsSubject
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: ListResponse<IddTraining>) => {
        this.iddTrainings = response.items;

        let newestIddTraining: IddTraining = null;
        this.iddTrainings.forEach((iddTraining: IddTraining) => {
          if (null === newestIddTraining) {
            newestIddTraining = iddTraining;
            return;
          }

          // if (newestIddTraining.year < iddTraining.year) {
          //   newestIddTraining = iddTraining;
          // }

          if (this.currentYear === iddTraining.year) {
            newestIddTraining = iddTraining;
          }
        });

        this.iddTrainingControl.setValue(newestIddTraining?.uuid);
      });
    merge(
      this.realisedAssetsMinutesPartControl.valueChanges,
      this.realisedAssetsHoursPartControl.valueChanges,
      this.realisedLifeMinutesPartControl.valueChanges,
      this.realisedGeneralMinutesPartControl.valueChanges,
      this.realisedLifeHoursPartControl.valueChanges,
      this.realisedGeneralHoursPartControl.valueChanges
    )
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.updateRealisedMinutes());

    this.iddTrainingControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((iddTrainingId: string) => {
        if (!iddTrainingId) {
          return;
        }

        this.iddTrainingService.get(iddTrainingId)
          .subscribe((iddTraining: IddTraining) => this.selectedIddTraining = iddTraining);
      });

    if (this.iddTrainingObject) {
      this.iddTrainingControl.setValue(this.iddTrainingObject.uuid);
    }
  }

  updateRealisedMinutes(): void {
    this.realisedAssetsMinutesControl.setValue(
      (this.realisedAssetsHoursPartControl.value * 60) + this.realisedAssetsMinutesPartControl.value
    );

    this.realisedLifeMinutesControl.setValue(
      (this.realisedLifeHoursPartControl.value * 60) + this.realisedLifeMinutesPartControl.value
    );

    this.realisedGeneralMinutesControl.setValue(
      (this.realisedGeneralHoursPartControl.value * 60) + this.realisedGeneralMinutesPartControl.value
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ofwcaChanged(ofwca: Ofwca): void {
    this.iddTrainingService.loadNotCountedList(
      0, 1000, {ofwca: ofwca.uuid}, this.iddTrainingsSubject
    );
    this.selectedOfwca = ofwca;
    this.selectedIddTraining = null;
  }

  save(): void {
    if (this.realisedAssetsMinutesControl.value < 1 && this.realisedLifeMinutesControl.value < 1 &&
      this.realisedGeneralMinutesControl.value < 1) {
      this.snack.open('Wskaż liczbę godzin szkolenia', '', {duration: 2000});
      return;
    }

    if (this.processingRequest) {
      return;
    }
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.certificateForm, this.formErrors);
    this.formErrors = {};

    this.iddTrainingService.addCertificate(this.iddTrainingControl.value, this.certificateForm.value)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open('Pomyślnie utworzono zaświadczenie', '', {
          duration: 2000,
        });

        if (this.dialogRef) {
          this.dialogRef.close();
        } else {
          const formValue = this.certificateForm.value;
          this.certificateForm.reset({
            ofwca: '',
            iddTraining: '',
            file: '',
            fileName: '',
            fileContent: '',
            meetingLeader: formValue.meetingLeader,
            aml: false,
            insuranceCompany: '',
            realisedAssetsMinutes: 0,
            realisedLifeMinutes: 0,
            realisedAt: '',
          });


          this.realisedAssetsHoursPartControl.setValue(0);
          this.realisedAssetsMinutesPartControl.setValue(0);
          this.realisedLifeHoursPartControl.setValue(0);
          this.realisedLifeMinutesPartControl.setValue(0);
          this.realisedGeneralHoursPartControl.setValue(0);
          this.realisedGeneralMinutesPartControl.setValue(0);
          this.selectedInsuranceCompany = null;
          this.selectedIddTraining = null;
          this.selectedOfwca = null;
          this.processingRequest = false;
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas tworzenia zaświadczenia wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.certificateForm, this.formErrors);
        }
      })
    ;
  }

  cancel(): void {
    if (!this.dialogRef) {
      this.router.navigate(['/szkolenia-idd']);
    } else {
      this.dialogRef.close();
    }
  }
  approve(): void {
    this.certificateForm.addControl(
      'fileLocation',
      new FormControl(this.certificate.fileLocation || '', /* optional validators */)
    );
    this.certificateForm.addControl(
      'fileName',
      new FormControl(this.certificate.fileName || '', /* optional validators */)
    );
    this.certificateForm.addControl(
      'imageLocation',
      new FormControl(this.certificate.imageLocation || '', /* optional validators */)
    );
    this.certificateForm.addControl(
      'uuid',
      new FormControl(this.certificate.uuid || '', /* optional validators */)
    );


    this.iddTrainingService.approveCertificate(this.certificate.uuid, this.certificateForm.value)
      .pipe(
        first()
      )
      .subscribe((response: any) => {
        this.snack.open('Pomyślnie zatwierdzono zaświadczenie', '', {
          duration: 2000,
        });

        if (this.dialogRef) {
          this.dialogRef.close(true);
        } else {
          const formValue = this.certificateForm.value;
          this.realisedAssetsHoursPartControl.setValue(0);
          this.realisedAssetsMinutesPartControl.setValue(0);
          this.realisedLifeHoursPartControl.setValue(0);
          this.realisedLifeMinutesPartControl.setValue(0);
          this.realisedGeneralHoursPartControl.setValue(0);
          this.realisedGeneralMinutesPartControl.setValue(0);
          this.selectedInsuranceCompany = null;
          this.selectedIddTraining = null;
          this.selectedOfwca = null;
          this.processingRequest = false;
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas zatwierdzenia zaświadczenia wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.certificateForm, this.formErrors);
        }
      })
    ;
  }

    deny(certificate: IddTrainingCertificate): void {
    const dialogRef = this.dialog.open(DenyIddCertificateDialogComponent, {
      width: '30vw',
      height: '30vh',
      panelClass: 'acceptIDD',
      autoFocus: false,
      data: {
        certificateId: certificate.uuid,
        certificateObject: certificate
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.certificateDenialForm = this.fb.group({
          declineReason: result
        });
        this.iddTrainingService.denyCertificate(this.certificate.uuid, this.certificateDenialForm.value)
          .pipe(
            first()
          )
          .subscribe((response: any) => {
            this.snack.open('Pomyślnie odrzucono zaświadczenie', '', {
              duration: 2000,
            });

            if (this.dialogRef) {
              this.dialogRef.close(true);
            } else {
              const formValue = this.certificateForm.value;
              this.realisedAssetsHoursPartControl.setValue(0);
              this.realisedAssetsMinutesPartControl.setValue(0);
              this.realisedLifeHoursPartControl.setValue(0);
              this.realisedLifeMinutesPartControl.setValue(0);
              this.realisedGeneralHoursPartControl.setValue(0);
              this.realisedGeneralMinutesPartControl.setValue(0);
              this.selectedInsuranceCompany = null;
              this.selectedIddTraining = null;
              this.selectedOfwca = null;
              this.processingRequest = false;
            }
          }, (error: HttpErrorResponse) => {
            this.processingRequest = false;
            this.snack.open('Podczas odrzucania zaświadczenia wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });
            if (error.status === 400) {
              this.formErrors = error.error.error.list;
              this.formHelper.setBackendErrorState(this.certificateForm, this.formErrors);
            }
          })
        ;
      }
    });
  }

  meetingLeaderChanged(meetingLeader: Dictionary): void {
    if (meetingLeader.key === MEETING_LEADER_INSURANCE_COMPANY) {
      this.insuranceCompanyControl.enable();
    } else {
      this.insuranceCompanyControl.disable();
      this.selectedInsuranceCompany = null;
    }
  }

  insuranceCompanyChanged(insuranceCompany: InsuranceCompany): void {
    this.selectedInsuranceCompany = insuranceCompany;
  }

  onCertImgError($event: any): void {
    $event.target.parentElement.parentElement.style.display = 'none';
  }


  floor(num: number): number {
    return Math.floor(num);
  }

  downloadCertificate(): void {
    this.iddTrainingService.downloadCertificateToCheck(this.certificate.uuid);
  }
}
